import { IconButton, Tooltip } from '@assembly-js/design-system';

import { HELP_CENTER_PAGE } from 'src/constants';
import { usePortalHealthStatus } from 'src/hooks/usePortalHealthStatus';
import { UrlUtils } from 'src/utils';

interface SidebarBottomBarProps {
  onSettingsClick: () => void;
  onHelpCenterClick: () => void;
  isClient: boolean;
  isHelpCenterOpen: boolean;
  isSettingsSelected: boolean;
}

const PortalButton = () => {
  const { isPortalReady, clientExperienceLink } = usePortalHealthStatus();

  return (
    <IconButton
      icon="ArrowNE"
      label="Open portal"
      variant="minimal"
      size="sm"
      disabled={!isPortalReady}
      onClick={() =>
        window.open(UrlUtils.GetFullUrl(clientExperienceLink), '_blank')
      }
    />
  );
};

export const SidebarBottomBar = ({
  onSettingsClick,
  onHelpCenterClick,
  isClient,
  isHelpCenterOpen,
  isSettingsSelected,
}: SidebarBottomBarProps) => {
  return (
    <div className="flex gap-1 px-2 py-1">
      <Tooltip content="Settings" position="right">
        <div aria-current={isSettingsSelected ? 'page' : undefined}>
          <IconButton
            icon="Settings"
            variant="minimal"
            size="sm"
            onClick={onSettingsClick}
          />
        </div>
      </Tooltip>
      {!isClient && (
        <Tooltip content={HELP_CENTER_PAGE.label} position="right">
          <div aria-expanded={isHelpCenterOpen}>
            <IconButton
              icon="QuestionMark"
              variant="minimal"
              size="sm"
              onClick={onHelpCenterClick}
            />
          </div>
        </Tooltip>
      )}
      {!isClient && <PortalButton />}
    </div>
  );
};
